import { render, staticRenderFns } from "./SeatGroupModal.vue?vue&type=template&id=eedae506&"
import script from "./SeatGroupModal.vue?vue&type=script&lang=js&"
export * from "./SeatGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eedae506')) {
      api.createRecord('eedae506', component.options)
    } else {
      api.reload('eedae506', component.options)
    }
    module.hot.accept("./SeatGroupModal.vue?vue&type=template&id=eedae506&", function () {
      api.rerender('eedae506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/SeatGroupModal.vue"
export default component.exports